import { render } from "./DailyMealPlan.vue?vue&type=template&id=934d8a1a&scoped=true"
import script from "./DailyMealPlan.vue?vue&type=script&lang=js"
export * from "./DailyMealPlan.vue?vue&type=script&lang=js"

import "./DailyMealPlan.vue?vue&type=style&index=0&id=934d8a1a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-934d8a1a"]])

export default __exports__